<template>
    <v-row justify="center">
        <v-dialog v-model="showDialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline pt-1 pr-1 custom-card-header">
                    Confirm Task Removal
                    <v-spacer></v-spacer>
                    <v-btn icon @click="toggle" dark><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <br />
                <v-card-text class="pb-1"> Are you sure you want to remove this task from the route ?</v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="danger" dark class="ma-2" @click="removeTask">Remove</v-btn>
                    <v-btn color="primary" outlined class="ma-2" @click="toggle">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    import { mapActions } from 'vuex'
    export default {
        props: {
            showDialog: {
                type: Boolean,
                required: true
            },
            toggle: {
                type: Function,
                required: true
            },
            jobTask: {
                type: Object
            },
        },
        methods: {
            ...mapActions({
                updateTask: 'jobTasks/update',
                getRoute: 'routes/getIsolatedRoute'
            }),
            async removeTask () {
                let routeId = this.jobTask.routeId
                this.jobTask.routeId = null
                this.jobTask.status = 'Unassigned'

                // Keep tag assignment
                if(this.jobTask.jobTaskTags && this.jobTask.jobTaskTags.length > 0) {
                    const tagIds = this.jobTask.jobTaskTags.map((tag) => tag.tag.id)
                    this.jobTask.tagIds = tagIds
                }

                await this.updateTask(this.jobTask)
                await this.getRoute(routeId)
                await this.toggle()
            }
        }
    }
</script>
<style scoped>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
</style>
